import { render, staticRenderFns } from "./Changelabel.vue?vue&type=template&id=15823454&scoped=true&"
import script from "./Changelabel.vue?vue&type=script&lang=js&"
export * from "./Changelabel.vue?vue&type=script&lang=js&"
import style0 from "./Changelabel.vue?vue&type=style&index=0&id=15823454&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15823454",
  null
  
)

export default component.exports